import { createTheme } from '@mui/material/styles';
import { SOFTWAREIQ_DOCUMENTATION_PALETTES } from '@softwareiq/brand-ui';

export const isDocumentationRoute = path => path === '/documentation' || path.startsWith('/documentation/') || path === '/mcp' || path === '/coverage';

export const getDocumentationPalette = theme => SOFTWAREIQ_DOCUMENTATION_PALETTES[theme.palette.mode];

export function getDocumentationTheme(theme) {
  const palette = getDocumentationPalette(theme);
  return createTheme(theme, {
    palette: {
      primary: { main: palette['--interactive'], dark: palette['--interactive-strong'], contrastText: palette['--on-action'] },
      text: { primary: palette['--heading'], secondary: palette['--muted'] },
      background: { default: palette['--background'], paper: palette['--surface-strong'] },
      divider: palette['--line'],
    },
    chrome: {
      documentation: true,
      headerBackdrop: palette['--background'],
      headerSurface: palette['--surface-strong'],
      headerBorder: palette['--line'],
      menuSurface: palette['--surface-strong'],
      menuContentSurface: palette['--surface-soft'],
    },
    components: {
      MuiButton: {
        styleOverrides: {
          containedPrimary: { backgroundColor: palette['--action-primary'], color: palette['--on-action'], '&:hover': { backgroundColor: palette['--action-primary-hover'] } },
        },
      },
    },
  });
}
